import * as React from "react";
import styled from "styled-components";
import { Trans } from '@lingui/react';

function LeadFormSent() {
    return (
        <Wrapper>
            <Heading>
                <Trans id="global.join_us.leadForm.sent.heading" />
            </Heading>
        </Wrapper>
    );
}

export default LeadFormSent;

const Wrapper = styled.div`
    background: #ffffff;
    box-shadow: 0px 0px 33px #e9edec;
    border-radius: 8px;
    padding: 35px;
    display: flex;
    flex-direction: column;
    max-width: 500px;
    margin: 0 auto;
`;

const Heading = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 35px;
    line-height: 120%;
    text-align: center;
    letter-spacing: -0.25px;
    color: #0cc8a8;
    margin-bottom: 20px;
`;
